export class EventsChannel {
    constructor(eventsService, channelPrefix) {
        this.eventsService = eventsService;
        this.channelPrefix = channelPrefix;
        this.subscriptionsMap = new Map();
    }
    on(eventPattern, handler) {
        this.subscribe(eventPattern);
        this.subscriptionsMap.get(eventPattern).handlers.add(handler);
    }
    off(eventPattern, handler) {
        if (!this.subscriptionsMap.has(eventPattern)) {
            return;
        }
        const subscription = this.subscriptionsMap.get(eventPattern);
        subscription.handlers.delete(handler);
        if (subscription.handlers.size === 0) {
            this.unsubscribe(eventPattern);
        }
    }
    destroy() {
        for (const eventName of this.subscriptionsMap.keys()) {
            this.unsubscribe(eventName);
        }
    }
    subscribe(eventPattern) {
        if (this.subscriptionsMap.has(eventPattern)) {
            return;
        }
        const fullPattern = `${this.channelPrefix}.${eventPattern}`;
        const unsubscribe = this.eventsService.subscribe(fullPattern, (event) => this.dispatchEvent(event));
        const subscription = {
            handlers: new Set(),
            pattern: this.eventsService.createPatternRegexp(fullPattern),
            unsubscribe,
        };
        this.subscriptionsMap.set(eventPattern, subscription);
    }
    unsubscribe(eventPattern) {
        if (!this.subscriptionsMap.has(eventPattern)) {
            return;
        }
        const subscription = this.subscriptionsMap.get(eventPattern);
        subscription.unsubscribe();
        this.subscriptionsMap.delete(eventPattern);
    }
    dispatchEvent(event) {
        for (const { pattern, handlers } of this.subscriptionsMap.values()) {
            if (!pattern.test(event.name)) {
                continue;
            }
            handlers.forEach(handler => handler(event));
        }
    }
}
